module.exports = require('./lib/client');



//////////////////
// WEBPACK FOOTER
// ./~/feathers-socketio/client.js
// module id = 1110
// module chunks = 0